import React from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaArrowRight } from "react-icons/fa";
import SafeImage from "@/components/SafeImage";

const DirectorDetails = ({
  sectionSpace = "pt-80 pb-90",
  image = "/img/imgs home/founder.webp",
  subTitle = "Meet the Director",
  bio = [
    "Coming from a humble Maharashtrian background, Dr. Kunal G. Padole has completed his MBA and Ph.D. in Management and brings over 16 years of entrepreneurial experience. Through his leadership in real estate development, education, and social initiatives, he has positively impacted the lives and careers of lakhs of students across Central India.",
    "As the founder of Siddhivinayak Infrastructure, he continues to build trust, quality, and long-term value through innovative real estate projects in Nagpur, driving the group's mission of delivering excellence in every project."
  ],
  highlights = [
    "MBA & Ph.D.",
    "16+ Years Experience",
    "Real Estate Visionary",
    "Education Leader",
    "Social Initiatives"
  ],
  quote = "“Always be positive. Be optimistic.”",
  phone = "+91 98232 60303",
  email = "mail@kunalpadole.com",
  address = "Siddhivinayak Infra No.1/3,731, Raje Raghuji Nagar, Opp. Kamala Nehru College, Nagpur - 440009",
  detailsHref = "/about",
}) => (
  <div className={`ltn__director-area ${sectionSpace}`} style={{ backgroundColor: "#f2f6f7" }}>
    <Container>
      {/* Title Header */}
      <Row className="mb-40">
        <Col xs={12}>
          <div className="section-title-area text-center mb-0">
          </div>
        </Col>
      </Row>

      {/* Main Grid Content */}
            <Row>
        {/* Left Column: Image */}
        <Col xs={12} lg={5} className="mb-4 mb-lg-0">
          <div
            style={{
              width: "100%",
              height: "650px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
            }}
          >
            <SafeImage
              src={image}
              alt="Dr. Kunal G. Padole - Founder, Siddhivinayak Infrastructure"
              width={650}
              height={650}
              sizes="(max-width: 991px) 100vw, 40vw"
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        </Col>

        {/* Right Column: Information */}
        <Col xs={12} lg={7} className="d-flex flex-column justify-content-between">
          <div className="about-us-info-wrap ps-lg-2">
            {/* Header Details */}
            <div className="section-title-area mb-25">
              <span className="section-subtitle section-subtitle-2 ltn__secondary-color mb-10">
                {subTitle}
              </span>
              <h2 className="mb-1">Dr. Kunal G. Padole</h2>
              <p className="ltn__secondary-color fw-bold mb-0">
                Founder – Siddhivinayak Infrastructure
              </p>
            </div>

            {/* Dynamic Bio Paragraphs */}
            <div className="director-bio-text mb-25">
              {Array.isArray(bio) ? (
                bio.map((paragraph, index) => (
                  <p key={index} className="mb-15" style={{ textAlign: "justify", lineHeight: "1.65" }}>
                    {paragraph}
                  </p>
                ))
              ) : (
                <p style={{ textAlign: "justify", lineHeight: "1.65" }}>{bio}</p>
              )}
            </div>

            {/* Pill Badges Layout */}
            <div className="d-flex flex-wrap gap-2 mb-30">
              {highlights.map((item, index) => (
                <span
                  key={index}
                  style={{
                    backgroundColor: "#f0f0f0",
                    color: "#4a5568",
                    padding: "8px 20px",
                    borderRadius: "50px",
                    fontSize: "14px",
                    fontWeight: "500",
                    display: "inline-block",
                    border: "1px solid #e2e8f0"
                  }}
                >
                  {item}
                </span>
              ))}
            </div>

            {/* Quote with Orange Left Border */}
            <div
              className="mb-30"
              style={{
                borderLeft: "4px solid #e28020",
                paddingLeft: "16px",
                margin: "20px 0"
              }}
            >
              <p
                style={{
                  fontSize: "22px",
                  fontStyle: "italic",
                  fontWeight: "500",
                  color: "#2d3748",
                  margin: 0,
                  lineHeight: "1.4"
                }}
              >
                {quote}
              </p>
            </div>

            {/* Contact Box Grid */}
            <div
              className="ltn__director-contact-box p-4 mb-30"
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                border: "1px solid #edf2f7"
              }}
            >
              <Row className="align-items-center g-3">
                <Col xs={12} sm={7} className="d-flex align-items-start">
                  <span className="ltn__secondary-color me-3 mt-1" style={{ fontSize: "18px" }}>
                    <FaMapMarkerAlt aria-hidden="true" />
                  </span>
                  <span className="text-muted" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                    {address}
                  </span>
                </Col>
                <Col xs={12} sm={5} className="d-flex flex-column gap-2 ps-sm-3 border-start-sm">
                  <div className="d-flex align-items-center">
                    <span className="ltn__secondary-color me-3" style={{ fontSize: "16px" }}>
                      <FaPhoneAlt aria-hidden="true" />
                    </span>
                    <a
                      href={`tel:${phone.replace(/\s+/g, "")}`}
                      className="text-dark fw-semibold"
                      style={{ fontSize: "14px", textDecoration: "none" }}
                    >
                      {phone}
                    </a>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="ltn__secondary-color me-3" style={{ fontSize: "16px" }}>
                      <FaEnvelope aria-hidden="true" />
                    </span>
                    <a
                      href={`mailto:${email}`}
                      className="text-dark fw-semibold"
                      style={{ fontSize: "14px", textDecoration: "none" }}
                    >
                      {email}
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>

  </div>
);

export default DirectorDetails;